<ng-container *ngIf="page && mapping && configuration">
  <br-page [configuration]="configuration" [mapping]="mapping" [page]="page">
    <ng-template let-page="page">
      <!-- Debug marketo form-->
      <ft-marketo-form id="xxx"> </ft-marketo-form>

      <div class="page">
        <!-- Header -->
        <ng-container brComponent="header-content"></ng-container>
        <!-- / Header -->

        <!-- Role Selector Modal. Appears when navigating away from a deep linked page if segment not set -->
        <ft-role-selector-modal [page]="page"></ft-role-selector-modal>
        <!-- Sign In Modal. Appears when called from link -->
        <ft-sign-in-modal [page]="page"></ft-sign-in-modal>

        <!-- Confiramtion modal for cart -->
        <ft-confirmation [page]="page"></ft-confirmation>

        <!-- TODO: SEPARATE INTO GENERIC LOADING SCREEN -->
        <ngx-spinner
          bdColor="#fff"
          size="medium"
          color="#e8e8e8"
          type="line-scale"
          [fullScreen]="true"
        ></ngx-spinner>
        <!-- SEPARATE INTO GENERIC LOADING SCREEN -->
        <!-- Spinner for Signin Flow -->
        <ngx-spinner
          name="signinSpinner"
          bdColor="rgba(0,0,0,0.6)"
          size="medium"
          color="#fff"
          type="line-scale"
          [fullScreen]="true"
        >
          <p *ngIf="spinnerDetails?.spinnerLoadingText" class="signinSpinner">
            {{ spinnerDetails?.spinnerLoadingText }}
          </p>
        </ngx-spinner>
        <!-- Spinner for Signin Flow -->
        <!-- Alert Component -->
        <ft-accounts-alerts
          [page]="page"
          [notificationDetails]="notificationDetails"
        ></ft-accounts-alerts>

        <!-- Site Alert Component -->
        <ft-site-alert [page]="page"></ft-site-alert>

        <!-- Role Selector Banner. Appears on gateway homepage when segment not set -->
        <ft-role-selector-banner [page]="page"></ft-role-selector-banner>

        <!-- if segment page restricted to segment -->
        <ng-container *ngIf="!segmentOk">
          <div edsGrid>
            <div class="container--wide">
              <div
                edsRow
                edsSpacing
                edsPadding
                edsPaddingTop="lg"
                edsPaddingBottom="lg"
              >
                <div edsCol>
                  <eds-notifications
                    [title]="'common.page-restricted-alert-title' | translate"
                    [body]="'common.page-restricted-alert-body' | translate"
                    hasIcon="true"
                    notificationType="warning"
                    [canClose]="false"
                  ></eds-notifications>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="segmentOk">
          <ng-container [ngSwitch]="layoutName">
            <ft-two-cols *ngSwitchCase="'twocol'" [page]="page"></ft-two-cols>

            <ft-equal-cols
              *ngSwitchCase="'equalcols'"
              [page]="page"
            ></ft-equal-cols>

            <!-- Tabbed layouts -->
            <ft-one-col-tabbed
              *ngSwitchCase="'onecol-tabs'"
              [numberOfTabs]="6"
              [page]="page"
              [isTemit]="isTemit"
            ></ft-one-col-tabbed>

            <!-- Two Column -->
            <ft-two-cols *ngSwitchCase="'twocols'" [page]="page"></ft-two-cols>

            <!-- Product Detail Page -->
            <ft-custom-layout
              *ngSwitchCase="'product-detail'"
              [page]="page"
              layout="productDetailLayout"
            ></ft-custom-layout>

            <!-- US  Index Page -->
            <ft-custom-layout
              *ngSwitchCase="'us-index'"
              [page]="page"
              layout="usIndexLayout"
            ></ft-custom-layout>

            <!-- Default to 12 cols -->
            <ft-one-col *ngSwitchDefault [page]="page"></ft-one-col>
          </ng-container>
        </ng-container>
      </div>

      <!-- Footer -->
      <ng-container brComponent="footer-content"></ng-container>

      <!-- Config goes at the bottom -->
      <ng-container brComponent="page-config"></ng-container>
      <ft-debug [page]="page"></ft-debug>

      <!-- External link dialog -->
      <eds-dialog id="external-link" [config]="dialogConfig"></eds-dialog>
      <!-- Custom external link dialog -->
      <eds-dialog
        id="external-link-custom"
        [config]="dialogConfigCustom"
      ></eds-dialog>

      <div ftPageEnd></div>
    </ng-template>
  </br-page>
</ng-container>
